/**
 * src/hooks/useScraping.js
 * React Query v5 hooks para scraping: estado, logs, trigger.
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getEstado, getLogs, triggerPipeline, getSchedulerJobs, getPipelineJobs } from '../api/scraping'

export function useEstado(clienteId) {
  return useQuery({
    queryKey: ['scraping', clienteId, 'estado'],
    queryFn: () => getEstado(clienteId),
    enabled: !!clienteId,
    refetchInterval: 30_000,   // polling cada 30s
  })
}

export function useLogs(clienteId, limit = 20) {
  return useQuery({
    queryKey: ['scraping', clienteId, 'logs', limit],
    queryFn: () => getLogs(clienteId, limit),
    enabled: !!clienteId,
    refetchInterval: 15_000,
  })
}

export function useTrigger(clienteId) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ tipo, dryRun = false }) => triggerPipeline(clienteId, tipo, dryRun),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['scraping', clienteId] })
    },
  })
}

export function usePipelineJobs(clienteId, limit = 8) {
  return useQuery({
    queryKey: ['scraping', clienteId, 'pipeline-jobs', limit],
    queryFn: () => getPipelineJobs(clienteId, limit),
    enabled: !!clienteId,
    // 10s: es la ventana en la que el worker toma un job (WORKER_POLL_INTERVAL=10).
    // Con los 15-30s del resto, un job podía nacer y morir entre dos refrescos.
    refetchInterval: 10_000,
  })
}

export function useSchedulerJobs() {
  return useQuery({
    queryKey: ['scheduler', 'jobs'],
    queryFn: getSchedulerJobs,
    refetchInterval: 60_000,
    retry: false,
  })
}
